import { FormGroup } from "@angular/forms";
import { FormFieldSettings } from "../../form-settings/form-field-settings";
import { ParentFieldFactory } from "../field-factory";
import { DynamicController } from "../dynamic-controller";
import { GroupFormFieldSetting } from "./group-form-field-setting";
import { FormContext } from "../../form/form-context";

export class DynamicGroupController<M = {}> extends DynamicController {
  constructor(
    private formGroup: FormGroup,
    private fieldFactory: ParentFieldFactory,
    private setting: GroupFormFieldSetting,
    private settings: FormFieldSettings
  ) {
    super();
  }

  public onInit(context: FormContext<M>) {}

  protected destory() {
    // TODO
  }
}
